import { compose, branch, renderComponent, renderNothing } from 'recompose';

export const ifAuthenticated = PrimaryComponent =>
  branch(
    props => props.isloggedin,
    renderComponent(PrimaryComponent),
    renderNothing
  )();

export const conditionalRender = states =>
  compose(
    ...states.map(state => branch(state.when, renderComponent(state.then)))
  );

export const isLoggedInUser = ({ isloggedin }) => isloggedin;
